<template>
  <el-main>
    <div class="formSubmitBtnBox">
      <el-button @click="Info(0)">新增講師</el-button>
    </div>
    <br />
    <el-row>
      <el-col :span="12"
        ><el-button
          icon="el-icon-delete-solid"
          style="margin:0 12px 0 0"
          @click="DeleteLecturerInfo()"
        ></el-button
        >選擇並刪除</el-col
      >
      <el-col :span="12" align="right"
        ><i class="el-icon-search"></i
        ><el-input
          style="width:200px; margin:0 16px"
          v-model="search"
          placeholder="搜尋姓名"
        />
        <el-button type="primary" style="margin:0 15px" @click="save()"
          >儲存</el-button
        >
      </el-col>
    </el-row>

    <br />

    <el-table
      v-loading="loading"
      :data="
        lecturerInfoList
          .filter((data) => !search || data.name.match(search))
          .slice((currentPage - 1) * pagesize, currentPage * pagesize)
      "
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :default-sort="{
        prop: 'invitedTimes,sort,startDate',
        order: 'descending',
      }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="" fixed width="10"> </el-table-column>
      <el-table-column label="講師" fixed width="70">
        <template slot-scope="scope">
          <ele-image
            fit="contain"
            :size="50"
            radius="50%"
            :username="scope.row.name"
            :src="scope.row.photoUrl"
            :preview-src-list="[scope.row.photoUrl]"
          ></ele-image>
        </template>
      </el-table-column>
      <el-table-column label="" fixed width="80">
        <template slot-scope="scope">
          <el-button
            class="btn2href"
            @click="Info(scope.row.id)"
            style="text-decoration:none;"
            >{{ scope.row.name }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="地區" width="320">
        <template class="area-for-div" slot-scope="scope">
          <div class="area-for-div">
            <div
              class="area-div"
              v-for="(item, index) in scope.row.lecturerAreaList"
              :key="index"
            >
              {{
                item === 1
                  ? '北部'
                  : item === 2
                  ? '中部'
                  : item === 3
                  ? '南部'
                  : item === 4
                  ? '東部'
                  : ''
              }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="邀請授課/演講"
        width="140"
        prop="invitedTimes"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.invitedTimes }}
        </template>
      </el-table-column>
      <el-table-column label="講師效期" width="200" prop="startDate" sortable>
        <template slot-scope="scope">
          {{
            scope.row.startDate.substring(0, 10).replace(/-/g, '/') +
              ' ~ ' +
              scope.row.endDate.substring(0, 10).replace(/-/g, '/')
          }}
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort" sortable>
        <template slot-scope="scope">
          <el-input v-model="scope.row.sort"></el-input>
        </template>
      </el-table-column>

      <el-table-column label="前台是否顯示">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.show"></el-checkbox>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100]"
        :page-size="pagesize"
        layout="total, sizes,prev, pager, next"
        :total="
          lecturerInfoList.filter((data) => !search || data.name.match(search))
            .length
        "
        prev-text="上一頁"
        next-text="下一頁"
      >
      </el-pagination>
    </div>

    <!-- importDailog -->
    <el-dialog
      title="匯入會員"
      :visible.sync="importDailog"
      width="30%"
      :close-on-click-modal="false"
    >
      <div class="dialog-info">
        <ol>
          <li style="padding:1.5px 0">
            <b>請先產生欲新增會員筆數之Excel，並下載Excel填入資料。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>會員資料填寫完畢後，選擇該Excel匯入。</b>
          </li>
          <li style="padding:1.5px 0">
            <b>如中途遇筆數不足，請重新產生，不可自行在Excel新增會員。</b>
          </li>
        </ol>
      </div>
      <br />
      <div>
        <p>1.下載系統Excel</p>
        <el-form label-width="80px" @submit.native.prevent>
          <el-form-item label="新增會員">
            <el-row>
              <el-col :span="15">
                <el-input
                  class="input-div"
                  placeholder="請輸入筆數"
                  v-model="addNums"
                  clearable
                ></el-input
              ></el-col>
              <el-col :span="9" align="right">
                <el-button @click="generateExcel()"
                  >產生Excel</el-button
                ></el-col
              >
            </el-row>
          </el-form-item>

          <el-button
            v-if="downloadBtn"
            @click="downloadExcel()"
            icon="el-icon-download"
            class="download-excel"
            >下載Excel</el-button
          >
          <div>
            <hr style="margin:20px 0px" />

            <p>2.將系統Excel匯入</p>
            <el-form-item label="上傳" prop="attachmentFile">
              <AttachmentFileUploader
                :fileQuantityLimit="1"
                :fileList.sync="excelFile"
              ></AttachmentFileUploader>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDailog = false">關閉</el-button>
      </div>
    </el-dialog>

    <!-- exportDailog
    <el-dialog title="匯出" :visible.sync="exportDailog" width="30%" :close-on-click-modal="false">
      <div class="dialog-info">
        <ol>
          <li style="padding:1.5px 0">
            <b>匯出之Excel再行匯入之後，皆會更改會員資料及 "第一筆" 培訓資料。</b>
          </li>
        </ol>
      </div>
      <br />
      <div class="export-div">
        <el-row class="export-div-inside">
          <el-col :span="12"><div>匯出選擇結果(施工中)</div></el-col>
          <el-col :span="12" align="right"><el-button type="primary">匯出</el-button></el-col>
        </el-row>
      </div>
      <br />
      <div class="export-div">
        <el-row class="export-div-inside">
          <el-col :span="12"><div>匯出全部</div></el-col>
          <el-col :span="12" align="right"
            ><el-button type="primary" @click="exportAll()">匯出</el-button></el-col
          >
        </el-row>
      </div>
      <br />
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDailog = false">關閉</el-button>
      </div>
    </el-dialog> -->
  </el-main>
</template>

<script>
import {
  C_Lecturer_GetList,
  C_Lecturer_DeleteList,
  C_Lecturer_UpdateList,
} from '@/assets/js/api';
import AttachmentFileUploader from '@/components/AttachmentFileUploader.vue';

export default {
  data() {
    return {
      currentPage: 1, // 默認顯示第一頁
      pagesize: 10, //    每頁顯示筆數
      selectedItem: 0,
      downloadBtn: false,
      importDailog: false,
      exportDailog: false,
      search: '',
      submitDialog: false,
      excelFile: [],
      multipleSelection: [],
      addNums: 0,
      lecturerInfoList: [],
      loading: true,
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-04',
          name: '王中虎',
          address: '上海市普陀区金沙江路 1517 弄',
        },
        {
          date: '2016-05-01',
          name: '王大虎',
          address: '上海市普陀区金沙江路 1519 弄',
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
        },
      ],
    };
  },
  components: {
    AttachmentFileUploader,
  },

  mounted() {
    this.getLecturerInfo();
  },
  watch: {
    importDailog() {
      if (this.importDailog === true) {
        this.downloadBtn = false;
        this.addNums = '';
        this.excelFile = [];
      } else {
        this.getLecturerInfo();
      }
    },
  },
  methods: {
    handleSizeChange(size) {
      this.pagesize = size;
      /* console.log(this.pagesize) */
    },
    // 点击第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      /* console.log(this.currentPage) */
    },
    Info(id) {
      this.$router.push({ path: `lecturerInfo/${id} ` });
    },
    generateExcel() {
      if (this.addNums > 0) {
        this.downloadBtn = true;
      } else {
        this.$message.error('請輸入大於 0 的數');
      }
    },
    handleCommand(command) {
      if (command === 'import') this.importDailog = true;
      if (command === 'export') this.exportDailog = true;
    },
    getLecturerInfo() {
      C_Lecturer_GetList()
        .then((res) => {
          this.lecturerInfoList = res.data.data;
          console.log(this.lecturerInfoList);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    save() {
      C_Lecturer_UpdateList(this.lecturerInfoList)
        .then((res) => {
          console.log(res);
          this.getLecturerInfo();
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
          });
        })
        .catch((err) => {
          console.log(err);
          this.$notify.error({
            title: '錯誤',
            message: '請確認欄位格式是否正確',
          });
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 刪除 Dialog
    DeleteLecturerInfo() {
      if (this.multipleSelection.length < 1) {
        this.$confirm('請先選擇資料後再操作', '')
          .then(() => {})
          .catch(() => {});
      } else {
        this.$confirm(
          `確定刪除 ${this.multipleSelection.length} 筆資料嗎?`,
          '刪除',
        )
          .then(() => {
            this.LecturerDeleteListAPI();
          })
          .catch(() => {});
      }
    },
    // 刪除API
    LecturerDeleteListAPI() {
      const selectedIds = this.multipleSelection.map((x) => x.id);
      const jsonObj = { MultId: selectedIds };
      C_Lecturer_DeleteList(jsonObj)
        .then(() => {
          this.$notify({
            title: '成功',
            message: '刪除成功',
            type: 'success',
          });
        })
        .catch((err) => {
          this.$notify({
            title: '刪除失敗',
            message: err.response.data.message,
            type: 'error',
          });
        })
        .finally(() => {
          this.getLecturerInfo();
        });
    },

    // submitExamInfoList() {
    //   this.submitDialog = false;
    //   C_ExamInfo_UpdateList()
    //     .then((res) => {
    //       this.$notify({
    //         title: '成功',
    //         message: '修改成功',
    //         type: 'success',
    //       });
    //       console.log(res.data.data.message);
    //     })
    //     .catch((err) => {
    //       console.log(err.response.data);
    //       this.$notify.error({
    //         title: '錯誤',
    //         message: '請確認欄位格式是否正確',
    //       });
    //     });
    // },
  },
};
</script>

<style lang="scss">
.tr-status-false {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 8px;
  width: 48px;
  height: 32px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  box-sizing: border-box;
  border-radius: 4px;
}
.tr-status-true {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 8px;
  width: 48px;
  height: 32px;
  background: #f4f4f5;
  border: 1px solid #e9e9eb;
  box-sizing: border-box;
  border-radius: 4px;
}

.dialog-info {
  background: #f5f7fa;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  padding: 3px;
}
.input-div {
  margin-right: 10px;
}
.download-excel {
  border: none;
  color: rgba(0, 0, 255, 0.849);
}
.user-img {
  border-radius: 50%;
}

.export-div {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.export-div-inside {
  align-items: center;
  display: flex;
  order: 1;
  margin: 16px 0px;
}
.area-for-div {
  display: flex;
}

.area-div {
  align-items: center;
  padding: 5px 8px;
  margin: 0 5px;
  width: 48px;
  height: 32px;
  background: #f4f4f5;
  border: 1px solid #e9e9eb;
  box-sizing: border-box;
  border-radius: 4px;
}
.btn2href {
  padding: 0;
  border: none;
  color: rgba(38, 0, 255, 0.884);
}
.pagination {
  margin: 10px 0 0 0;
  text-align: center;
}
</style>
